import { Link } from '@ardoq/typography';
import { Hero, Stack } from '@ardoq/layout';
import styled from 'styled-components';
import { t } from '@ardoq/i18n';
import { getPreAppI18nLocale } from 'preAppI18nBootstrap';

const ButtonLink = styled(Link)`
  display: flex;
  justify-content: center;
`;

const MissingOrgPage = () => {
  const i18nLocale = getPreAppI18nLocale();
  return (
    <Hero.Container>
      <Hero.Stack>
        <Hero.Header
          title={t(i18nLocale, 'missingOrg:title', 'No organization found')}
        />
        <Hero.PlainTextContainer>
          <Stack gap="medium">
            <div>
              {t(
                i18nLocale,
                'missingOrg:body.unlinked',
                "Your account isn't linked to any organization."
              )}
            </div>
            <div>
              {t(
                i18nLocale,
                'missingOrg:body.contactPrefix',
                'Please contact '
              )}
              <Link href="mailto:support@ardoq.com" hideIcon>
                {/* i18n-ignore-next-line */}
                support@ardoq.com
              </Link>
              {t(
                i18nLocale,
                'missingOrg:body.contactSuffix',
                ' for more information or sign in with a different account.'
              )}
            </div>
          </Stack>
        </Hero.PlainTextContainer>
        <Hero.ActionsContainer>
          <ButtonLink type="primaryButton" href="/logout" hideIcon>
            {t(
              i18nLocale,
              'missingOrg:signInDifferentAccount',
              'Sign in with a different account'
            )}
          </ButtonLink>
        </Hero.ActionsContainer>
      </Hero.Stack>
    </Hero.Container>
  );
};

export { MissingOrgPage };
